import React from "react";
import { DropzoneArea } from "material-ui-dropzone";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
}));
function UploadSign({setFieldValue, handleBase64String }) {
  const handleImage = async (files) => {
    const imagedata = files[0];
    if (imagedata) {
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      const base64Data = await toBase64(imagedata);
      handleBase64String(base64Data);
    }
  };
  const classes = useStyles();
  return (
    <div>
      <DropzoneArea 
        acceptedFiles={["image/png", "image/jpeg", "image/jpg"]}
         dropzoneText={
          <span style={{ fontSize: "16px" }}>
            <Typography>
              Drag 'n' drop signature file here, or click to select file
            </Typography>
            <em>
              (Accepted File Formats: JPG, PNG, JPEG. Max file size 200KB)
            </em>
          </span>
        }
        maxFileSize={200000}
        filesLimit={1}
        onChange={(files) => handleImage(files)}
        onDelete={() => setFieldValue("authorization.signature", "")}
      />
    </div>
  );
}

export default UploadSign;
